import {
    GoogleMap, LoadScript, Marker
} from "@react-google-maps/api";
import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import Buttons from '../components/Buttons';
import images from '../config/images';
import mapStyles from '../config/mapStyles';
import GeoPortailMap from '../components/GeoPortailEventMap';

const HomeContainer = styled.div`
    width: 100%;
    height: 100%;
`;

const GoogleMapWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`;


const Plan = () => {


    return (
        <GeoPortailMap />
    );
}

export default Plan;
